import { Middleware } from "redux";

import { Activity, ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { Locale } from "@com.mgmtp.a12.utils/utils-localization/lib/main";

import { isWorkflowActivity } from "../../../utilities/activityUtils";
import { createEnableValidationStateFormEngineAction, VALIDATION_ACTIONS } from "../../../utilities/workflowUtils";

export const setValidateNextAfterLoadingOrSavingMiddleware: Middleware<unknown, { locale: Locale }> =
	api => next => action => {
		if (
			!ActivityActions.setData.match(action) &&
			!ActivityActions.save.done.match(action) &&
			!ActivityActions.save.failed.match(action)
		) {
			return next(action);
		}

		const activityId = ActivityActions.setData.match(action)
			? action.payload.activityId
			: action.payload.params.activityId;

		const activity = ActivitySelectors.activityById(activityId)(api.getState());

		if (!isWorkflowActivity(activity)) {
			return next(action);
		}

		const dataHolder = Activity.findDefaultDataHolder(activity);
		if (dataHolder?.loadingState !== "loading" && dataHolder?.savingState !== "saving") {
			return next(action);
		}

		// Dies darf erst nach der Überprüfung des Loading- und Saving-States gemacht werden
		// und sollte vor dem ersten Dispatch passieren
		const result = next(action);

		api.dispatch(createEnableValidationStateFormEngineAction(activityId, VALIDATION_ACTIONS.COMPLETE));
		api.dispatch(ActivityActions.setDirty({ activityId, dirty: false }));

		return result;
	};
